module.exports = __webpack_public_path__ + "img/8d88394.svg";